import {useState, useEffect} from 'react';

const format = time => {
    const days = Math.floor(time / (24 * 60 * 60 * 1e3));
    time -= days * (24 * 60 * 60 * 1e3);

    const hours = Math.floor(time / (60 * 60 * 1e3));
    time -= hours * (60 * 60 * 1e3);

    const minutes = Math.floor(time / (60 * 1e3));
    time -= minutes * (60 * 1e3);

    const seconds = Math.floor(time / 1e3);

    let string = ``;

    if(days > 0) string += `${days}d `;
    if(hours > 0) string += `${hours}h `;
    if(minutes > 0) string += `${minutes}m `;
    string += `${seconds}s `;

    return string.trim();
}

export default ({task_key, timeout}) => {
    const [time, setTime] = useState(timeout - Date.now())

    useEffect(() => {
        window[`${task_key}_timeout`] = setTimeout(() => setTime(time - 500), 500);
        return () => clearTimeout(window[`${task_key}_timeout`])
    }, [time]);

    if(time <= 0)
        return 'RELOAD';

    return format(time);
}